import { useState } from 'react';

import { EmptyStateGrayscaleImage, ErrorState404GrayscaleImage, SearchEmptyState } from '@assets/images';
import EmptyState from '@components/emptyState';
import { ConditionalComponent } from '@components/functionComponent';
import TableTemplate2 from '@components/tableTemplate2';
import { TextRegular } from '@components/typography';
import useGetSelloutMonitoring from '@domain/selloutMonitoring/useSelloutMonitoring';
import { useGlobalFilter } from '@pages/SelloutMonitoring/hooks/state/globalFilter';
import { useFilter } from '@pages/SelloutMonitoring/hooks/state/filters';

import { getTableList } from './const';
import './styles.css';

const Table = () => {
    const globalFilters = useGlobalFilter();
    const filters = useFilter();
    const tableList = getTableList(globalFilters.sellout_value);
    const [sortType, setSortType] = useState();
    const { data, isLoading, isError } = useGetSelloutMonitoring({
        ...globalFilters,
        ...filters,
        sort: sortType,
    });
    const handlePageClick = ({ selected }) => filters.setFilter({ page: selected + 1 });
    const onChangeLimit = (e) => filters.setFilter({ page: 1, limit: e.target.value });

    return (
        <ConditionalComponent
            statement={globalFilters.enabled}
            fallback={
                <EmptyState
                    text="Data belum tersedia"
                    image={<EmptyStateGrayscaleImage />}
                    description={
                        <TextRegular>Pilih dan isi keterangan di atas untuk menampilkan data sellout.</TextRegular>
                    }
                />
            }
        >
            <ConditionalComponent
                statement={!isError}
                fallback={
                    <EmptyState
                        text="Terjadi Kesalahan Pada Sistem"
                        image={<ErrorState404GrayscaleImage />}
                        description={<TextRegular>Mohon tunggu beberapa saat kemudian silahkan coba lagi.</TextRegular>}
                    />
                }
            >
                <TableTemplate2
                    isLoading={isLoading}
                    data={data?.data}
                    tableList={tableList}
                    totalData={data?.totalData}
                    totalPage={data?.totalPage}
                    handlePageClick={handlePageClick}
                    isPagination
                    isSearch={filters?.search}
                    page={filters?.page}
                    dataCount={data?.data?.length}
                    limit={filters?.limit}
                    onChangeLimit={onChangeLimit}
                    sortType={sortType}
                    noResultSearchImage={<SearchEmptyState />}
                    description={<>Mohon tunggu beberapa saat kemudian silahkan coba lagi.</>}
                    onSort={(value) => {
                        if (sortType?.name === value) {
                            setSortType({ type: sortType.type === 'desc' ? 'asc' : 'desc', name: value });
                        } else {
                            setSortType({ type: 'desc', name: value });
                        }
                    }}
                />
            </ConditionalComponent>
        </ConditionalComponent>
    );
};

export default Table;
